import { dataelementAPI } from 'api/dataelement';
import { UpdateDataelementDto } from 'dto/dataelement';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
};

export function useUpdateDataelement(props: PropsType) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (payload: UpdateDataelementDto) =>
      dataelementAPI.update(props.id, payload),
    onSuccess: (data) => {
      queryClient.setQueryData(
        [QUERY_KEY.FIND_ONE_DATAELEMENT, props.id],
        data
      );
      toast(locales.updateSuccess, { type: 'success' });
    },
  });

  return mutation;
}
